import {
  AddressWithCopy,
  MockLoadingTable,
  Token,
} from '@/components/molecules'
import {
  Circle,
  HStack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react'
import { useAccount } from 'wagmi'

export const SubscriptionTable = ({
  subscription: {
    subId,
    owner,
    consumersCount,
    reqCount,
    formattedBalance,
  } = {},
  isLoading,
}) => {
  const { chain } = useAccount()
  const blockExplorerUrl = chain?.blockExplorers?.default?.url

  return isLoading ? (
    <MockLoadingTable
      headers={['ID', 'Admin Address', 'Consumers', 'Fulfillments', 'Balance']}
    />
  ) : (
    <TableContainer>
      <Table>
        <Thead>
          <Tr>
            <Th>ID</Th>
            <Th>Admin address</Th>
            <Th>Consumers</Th>
            <Th>Fulfillments</Th>
            <Th>Balance</Th>
          </Tr>
        </Thead>

        <Tbody>
          <Tr key={subId}>
            <Td>
              <HStack>
                <Circle
                  size={'16px'}
                  bg={'green.400'}
                  boxShadow={'0 0 0 1px LightGray'}
                  border={'3px solid'}
                  borderColor={'primary.50'}
                />
                <Text>{subId}</Text>
              </HStack>
            </Td>
            <Td>
              {owner && (
                <AddressWithCopy
                  to={`${blockExplorerUrl}/address/${owner}`}
                  address={owner}
                  symbols={5}
                />
              )}
            </Td>
            <Td>{consumersCount}</Td>
            <Td>{reqCount}</Td>
            <Td>
              <Token
                amount={formattedBalance}
                decimal={4}
                toFtn={false}
                symbol={'FTN'}
              />
            </Td>
          </Tr>
        </Tbody>
      </Table>
    </TableContainer>
  )
}
